import React, {useEffect} from 'react'
import { makeStyles, useTheme } from '@material-ui/styles';
import { Typography, Grid, Card  } from '@material-ui/core';
import { LinearProgress, CircularProgress } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
    
    root: {
     display:'flex',
     flexDirection: 'column',
     flex:1,
    },
    gridContainerOuter:{
        margin: '6px -6px',
        display: 'flex',
        justifyContent: 'center'
    },
    gridItemInner: {
        padding : '3px 6px',
        width: '100%'
    },
    titleDiv: {
        padding: '8px 0px 12px 0px'
    },
    divTitle: {
        padding: 14,
        borderBottom: '1px solid lightgrey'
    },
    divContent: {
        padding: 12,
    },
    linear:{
        marginTop: 18
    },
    cardBody: {
        height: '100%'
    }
}));

function ProgressComp() {
    const classes = useStyles();
    const [progress, setProgress] = React.useState(0);

    useEffect(()=>{
        const ticks=()=>{
            setProgress((prevProg)=> (prevProg >= 100 ? 0 : prevProg+1) )
        }

        const timer= setInterval(ticks,20)
        return ()=>{
            clearInterval(timer)
        }
    },[]);

    return (
        <div className={classes.root}>
        <div className={classes.titleDiv}>
            <Typography variant="h2">Progress</Typography>
        </div>
        <Grid container className={classes.gridContainerOuter}>
            <Grid item xs={12} md={6} className={classes.gridItemInner}>
                <Card className={classes.cardBody}>
                    <div className={classes.divTitle}>
                        <Typography variant="h5" color="inherit">
                        Circular Indeterminate
                    </Typography>
                    </div>
                    <div className={classes.divContent}>
                    <CircularProgress  />
                    <CircularProgress  color="secondary" />
                    </div>
                </Card>
            </Grid>
            <Grid item xs={12} md={6} className={classes.gridItemInner}>
                <Card className={classes.cardBody}>
                    <div className={classes.divTitle}>
                        <Typography variant="h5" color="inherit">
                        Circular Determinate
                    </Typography>
                    </div>
                    <div className={classes.divContent}>
                    <CircularProgress variant="determinate" value={progress} />
                    <CircularProgress variant="determinate" value={progress} color="secondary" />
                    </div>
                </Card>
            </Grid>

        </Grid>

        <Grid container className={classes.gridContainerOuter}>
            <Grid item xs={12} md={6} className={classes.gridItemInner}>
                <Card className={classes.cardBody}>
                    <div className={classes.divTitle}>
                        <Typography variant="h5" color="inherit">
                        Circular Static
                    </Typography>
                    </div>
                    <div className={classes.divContent}>
                        <CircularProgress variant="static" value={50} />
                        <CircularProgress variant="static" value={75} />
                        <CircularProgress variant="static" value={100} />
                    </div>
                </Card>
            </Grid>
            <Grid item xs={12} md={6} className={classes.gridItemInner}>
                <Card className={classes.cardBody}>
                    <div className={classes.divTitle}>
                        <Typography variant="h5" color="inherit">
                        Linear Indeterminate
                    </Typography>
                    </div>
                    <div className={classes.divContent}>
                        <LinearProgress  className={classes.linear}/>
                        <LinearProgress className={classes.linear} color="secondary" />
                    </div>
                </Card>
            </Grid>

        </Grid>

        <Grid container className={classes.gridContainerOuter}>
            <Grid item xs={12} md={6} className={classes.gridItemInner}>
                <Card className={classes.cardBody}>
                    <div className={classes.divTitle}>
                        <Typography variant="h5" color="inherit">
                        Linear Determinate
                    </Typography>
                    </div>
                    <div className={classes.divContent}>
                    <LinearProgress variant="determinate" value={progress} className={classes.linear}/>
                    <LinearProgress variant="determinate" value={progress} color="secondary" className={classes.linear}/>
                    </div>
                </Card>
            </Grid>
            <Grid item xs={12} md={6} className={classes.gridItemInner}>
                <Card className={classes.cardBody}>
                    <div className={classes.divTitle}>
                        <Typography variant="h5" color="inherit">
                        Linear Query

                    </Typography>
                    </div>
                    <div className={classes.divContent}>
                    <LinearProgress variant="query" className={classes.linear}/>
                    <LinearProgress variant="query" color="secondary" className={classes.linear}/>
                    
                    </div>
                </Card>
            </Grid>

        </Grid>

    </div>

    )
}

export default ProgressComp
